;(function () {
  /* neverover — "See the outfit" (complete-the-look) sidebar as a MOBILE bottom sheet.
     Desktop keeps the right-hand sidebar (nv-ui-fixes pins that; it bails on mobile).
     The theme's sidebar-component animates with the Web Animations API on the X axis,
     so on mobile we cancel its animations and pin translateY ourselves, mirror the
     filter sheet's look (rounded top, scrim, grab handle), and wire the same
     drag-to-close: panel follows the finger; release far/fast → slides out fully;
     otherwise snaps back. All inline writes use the 'important' priority because the
     sheet CSS pins transform/transition with !important. */
  if (window.__nvSheets) return;
  window.__nvSheets = true;

  var EASE = 'transform .36s cubic-bezier(.32,.72,0,1)';
  var SEL = 'sidebar-component.instagram-sidebar.annc-sidebar';
  function isMobile(){ return window.matchMedia('(max-width:767px)').matches; }

  var css =
  '@media (max-width:767px){' +
    SEL + '{position:fixed!important;left:0!important;right:0!important;bottom:0!important;top:auto!important;' +
      'width:100%!important;max-width:100%!important;height:auto!important;max-height:82dvh!important;' +
      'border-radius:16px 16px 0 0!important;overflow:hidden!important;box-shadow:0 -10px 34px rgba(20,20,22,.16)!important;' +
      'background:#fff!important;transform:translateY(100%);transition:' + EASE + '!important;z-index:8890!important;}' +
    SEL + '.is-opened{transform:translateY(0)!important;}' +
    SEL + ' .sidebar__body{display:flex!important;flex-direction:column!important;width:100%!important;max-width:100%!important;' +
      'max-height:82dvh!important;height:auto!important;padding-top:0!important;}' +
    SEL + ' .inside-carousel{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;padding-bottom:calc(14px + env(safe-area-inset-bottom));}' +
    SEL + ' .quote-sidebar__close-button-container{touch-action:none;cursor:grab;}' +
    '#nv-outfit-scrim{position:fixed;inset:0;background:rgba(20,20,22,.45);opacity:0;visibility:hidden;transition:opacity .32s ease;z-index:8889;}' +
    '#nv-outfit-scrim.is-visible{opacity:1;visibility:visible;}' +
  '}';
  var st = document.createElement('style');
  st.id = 'nv-sheets';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  function scrim(){
    var s = document.getElementById('nv-outfit-scrim');
    if (!s){
      s = document.createElement('div'); s.id = 'nv-outfit-scrim';
      (document.body || document.documentElement).appendChild(s);
      s.addEventListener('click', function(){
        var sb = document.querySelector(SEL + '.is-opened');
        if (sb) animateClose(sb);
      });
    }
    return s;
  }

  function realClose(sb){
    var b = sb.querySelector('[data-sidebar-button][data-sidebar-id="' + sb.id + '"]');
    if (b) b.click(); else sb.classList.remove('is-opened');
  }

  function animateClose(sb){
    if (sb._nvClosing) return;
    sb._nvClosing = true;
    scrim().classList.remove('is-visible');
    sb.style.setProperty('transition','none','important');
    if (!sb.style.transform) sb.style.setProperty('transform','translateY(0)','important');
    void sb.offsetHeight;
    sb.style.setProperty('transition', EASE, 'important');
    sb.style.setProperty('transform','translateY(100%)','important');
    var done = false;
    function fin(){
      if (done) return; done = true;
      sb.style.removeProperty('transition'); sb.style.removeProperty('transform');
      sb._nvClosing = false;
      realClose(sb);
    }
    sb.addEventListener('transitionend', function h(e){
      if (e.target === sb && e.propertyName === 'transform'){ sb.removeEventListener('transitionend', h); fin(); }
    });
    setTimeout(fin, 430);
  }

  function wireDrag(sb, els){
    var startY = 0, dy = 0, dragging = false, lastY = 0, lastT = 0, vel = 0;
    function down(e){
      if (!isMobile()) return;
      dragging = true; sb._nvDragging = true; dy = 0; vel = 0;
      startY = lastY = (e.touches ? e.touches[0].clientY : e.clientY); lastT = Date.now();
      sb.style.setProperty('transition','none','important');
    }
    function move(e){
      if (!dragging) return;
      var y = (e.touches ? e.touches[0].clientY : e.clientY);
      var t = Date.now(); if (t > lastT) vel = (y - lastY) / (t - lastT);
      lastY = y; lastT = t;
      dy = Math.max(0, y - startY);
      sb.style.setProperty('transform','translateY(' + dy + 'px)','important');
    }
    function up(){
      if (!dragging) return; dragging = false; sb._nvDragging = false;
      var h = sb.offsetHeight || 600;
      if (dy > h * 0.22 || (dy > 30 && vel > 0.55)){ animateClose(sb); }
      else {
        sb.style.setProperty('transition', EASE, 'important');
        sb.style.setProperty('transform','translateY(0)','important');
      }
    }
    els.forEach(function (el){ if (!el) return; el.addEventListener('touchstart', down, { passive: true }); el.addEventListener('mousedown', down); });
    document.addEventListener('touchmove', move, { passive: true });
    document.addEventListener('mousemove', move);
    document.addEventListener('touchend', up);
    document.addEventListener('mouseup', up);
  }

  function addHandle(sb){
    var body = sb.querySelector('.sidebar__body');
    if (!body || body.querySelector('.nv-sheet-handle')) return;
    var h = document.createElement('div');
    h.className = 'nv-sheet-handle';            // styled by the filter-sheet CSS (shared look)
    h.setAttribute('aria-hidden', 'true');
    body.insertBefore(h, body.firstChild);
    wireDrag(sb, [h, body.querySelector('.quote-sidebar__close-button-container')]);
  }

  function pinY(sb){
    if (!isMobile()) return;
    var opened = sb.classList.contains('is-opened');
    try { sb.getAnimations().forEach(function (a){ a.cancel(); }); } catch (e) {}
    if (!sb._nvDragging && !sb._nvClosing){
      sb.style.setProperty('transform', opened ? 'translateY(0)' : 'translateY(100%)', 'important');
    }
    if (!sb._nvClosing) scrim().classList.toggle('is-visible', opened);
    if (opened) addHandle(sb);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[data-sidebar-button]');
    if (!btn || !isMobile()) return;
    var id = btn.getAttribute('data-sidebar-id');
    if (!id) return;
    var sb = document.getElementById(id);
    if (!sb || !sb.matches || !sb.matches(SEL)) return;
    [30, 90, 200, 360, 520].forEach(function (d){ setTimeout(function (){ pinY(sb); }, d); });
  }, true);

  function boot(){
    document.querySelectorAll(SEL).forEach(function (sb){
      if (sb._nvObs) return;
      sb._nvObs = new MutationObserver(function (){ pinY(sb); });
      sb._nvObs.observe(sb, { attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
